<div class="tw-relative popup-settings tw-p-[30px] tw-pt-[50px]">
    <button
        class="tw-absolute tw-top-4 tw-right-4 tw-text-gray-500 hover:tw-text-gray-700"
        (click)="closeDialog()"
    >
        <mat-icon>close</mat-icon>
    </button>
    <h2 class="!tw-font-bold !tw-text-[24px] !tw-mb-3">
        {{ "REMINDER" | translate }}
    </h2>
    <div class="content">
        <p>
            {{ "INSURANCE_PAGE.DISCLAIMER_1" | translate }}
        </p>
        <p>
            {{ "INSURANCE_PAGE.DISCLAIMER_2" | translate }}
        </p>
        <p>
            {{ "INSURANCE_PAGE.DISCLAIMER_3" | translate }}
        </p>
        <p>
            {{ "INSURANCE_PAGE.DISCLAIMER_4" | translate }}
        </p>
        <p>
            {{ "INSURANCE_PAGE.DISCLAIMER_4.1" | translate }}
        </p>
        <p>
            {{ "INSURANCE_PAGE.DISCLAIMER_4.2" | translate }}
        </p>
        <p>
            {{ "INSURANCE_PAGE.DISCLAIMER_5" | translate }}
        </p>
    </div>
    <div class="tw-flex tw-justify-center tw-items-center tw-gap-4">
        <button
            [attr.ga-event-id]="productSlug + '_cancel_main_insurance_click'"
            ga-event-category="Insurance Page Button"
            ga-event-label="Cancel Button Click"
            ga-track="track"
            (click)="closeDialog()"
            class="tw-cursor-pointer tw-text-[#8D8D8D]"
        >
            {{ "CANCEL" | translate }}
        </button>
        <a
            [attr.ga-event-id]="productSlug + '_proceed_insurance_click'"
            ga-event-category="Insurance Page Button"
            ga-event-label="Proceed Button Click"
            ga-track="track"
            href="{{ product.redirectUrl }}"
            target="_blank"
            class="tw-bg-[#4B6EEC] tw-px-[15px] tw-py-[10px] tw-rounded-full tw-cursor-pointer tw-text-white"
        >
            {{ "COMMON.APPLY_NOW" | translate }}
        </a>
    </div>
</div>
